/** Created by azhou on 2019/1/16.*/
<template>
  <div class="pb-5">
    <!--表单错误提示-->
    <el-alert class="mb-3" v-show="errorTips" :title="errorTips" type="error" center show-icon />
    <bg-grey-input label-text="手机号" placeholder="请输入手机号" type="number" v-model="phoneNumber"/>
    <send-phone-code :phone-number="phoneNumber"
                     input-type="grey"
                     :url='code'
                     @getCode="code=>this.phoneCode = code"
                     @showError="text=>this.errorTips = text"
                     :template="codeTemp"/>
    <bg-grey-input label-text="联系人" placeholder="请输入联系人" v-model="linkman" v-if="paramsType==='reg'"/>
    <bg-grey-input label-text="密码" placeholder="请输入六位数密码" type="password" v-model="regPassword"/>
    <bg-grey-input label-text="确认密码" placeholder="请再次输入密码" type="password" v-model="confirmPassword"/>
    <div class="d-center-between register-type-wrap" v-if="paramsType==='reg'">
      <div class="register-type d-center" @click="typeFlag = 3" :class="{active:typeFlag===3}">供应商</div>
      <div class="register-type d-center ml-2" @click="typeFlag = 2" :class="{active:typeFlag===2}">采购商</div>
    </div>
    <div class="agree-wrap">
      <div class="mb-3 ml-auto mr-auto h5" v-if="paramsType==='reg'">
        <el-checkbox v-model="agreeFlag">同意</el-checkbox>
        <router-link :to="{name:'regDoc',query:{anch:'0'}}">《服务条款》、</router-link>
        <router-link :to="{name:'regDoc',query:{anch:'1'}}">《隐私服务》、</router-link>
        <router-link :to="{name:'regDoc',query:{anch:'2'}}">《免责说明》</router-link>
      </div>
      <el-button @click="submitForm"
                 :disabled="!agreeFlag && paramsType==='reg'"
                 class="mt-2 mb-2 w-100 btn-login">{{paramsType==='reg' ? '注册' : '提交'}}
      </el-button>
    </div>
  </div>
</template>

<script>
  import { mapActions } from 'vuex'

  export default {
    name: 'RegPhone',
    computed: {
      paramsType () {
        return this.$route.path.split('/')[2]
      },
      code () {
        if (this.paramsType === 'reg') return '/pc/Reglogin/GetRegCode'
        if (this.paramsType === 'reset') return '/pc/Reglogin/GetFindCode'
        return ''
      },
      codeTemp () {
        if (this.paramsType === 'reg') return 'SMS_269225220'
        if (this.paramsType === 'reset') return 'SMS_269045228'
        return ''
      }
    },
    data () {
      return {
        phoneNumber: '',
        phoneCode: '',
        linkman: '',
        regPassword: '',
        confirmPassword: '',
        typeFlag: 3,
        errorTips: '',
        agreeFlag: false
      }
    },
    methods: {
      ...mapActions(['RegisterPhone','ResetPwd']),
      /*表单验证*/
      validateForm () {
        if (!this.$GFUN.isPhone(this.phoneNumber)) return { code: false, msg: '手机号填写不正确' }
        if (!this.phoneCode) return { code: false, msg: '请填写验证码' }
        if (!this.regPassword) return { code: false, msg: '请填写密码' }
        if (!this.confirmPassword) return { code: false, msg: '请填写确认密码' }
        if (this.regPassword !== this.confirmPassword) return { code: false, msg: '两次密码不一致' }
        if (this.paramsType === 'reg') {
          if (!this.$GFUN.isName(this.linkman)) return { code: false, msg: '请填写正确的联系人姓名' }
          if (!this.typeFlag) return { code: false, msg: '请选择注册类型' }
        }
        this.errorTips = ''
        return { code: true, msg: '表单验证通过' }
      },
      /*提交注册、重置密码*/
      submitForm () {
        let result = this.validateForm()
        if (result.code) {
          if (this.paramsType === 'reg') {                      //用户注册
            this.RegisterPhone({
              type: this.typeFlag,
              contact: this.linkman,
              password: this.regPassword,
              repassword: this.confirmPassword,
              mob: this.phoneNumber,
              sms_code: this.phoneCode,
              trace: 1
            });
          }
          if (this.paramsType === 'reset') {                   //用户重置登录密码
            this.ResetPwd({
              mobile: this.phoneNumber,
              pwd : this.regPassword,
              pwd2: this.confirmPassword,
              sms_code: this.phoneCode
            });
          }
        } else this.errorTips = result.msg
      },
    }
  }
</script>
<style lang="scss" scoped>
  @import '@/assets/css/color.scss';

  .register-type-wrap {
    width: 362px;
    margin: auto;
    .register-type {
      background: #eee;
      border: 1px solid #ccc;
      border-radius: 5px;
      height: 35px;
      font-size: 16px;
      flex: 1;
      cursor: pointer;
      &:hover {
        background: var(--smtc-color-primary);
        color: #fff;
      }
    }
    .active {
      background: var(--smtc-color-primary);
      color: #fff;
    }
  }

  .agree-wrap {
    width: 365px;
    margin: 40px auto;
    a {
      color: $loginBlue;
      font-size:14px;
    }
  }

  .el-button.is-disabled:hover {
    color: #fff;
    background-color: $disabledLoginBlue;
    border-color: $disabledLoginBlue;
  }
</style>
